import { render, staticRenderFns } from "./GroupsListItem.vue?vue&type=template&id=679cf445&scoped=true"
import script from "./GroupsListItem.ts?vue&type=script&lang=ts&external"
export * from "./GroupsListItem.ts?vue&type=script&lang=ts&external"
import style0 from "./GroupsListItem.vue?vue&type=style&index=0&id=679cf445&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679cf445",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('679cf445')) {
      api.createRecord('679cf445', component.options)
    } else {
      api.reload('679cf445', component.options)
    }
    module.hot.accept("./GroupsListItem.vue?vue&type=template&id=679cf445&scoped=true", function () {
      api.rerender('679cf445', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Auth/components/GroupsList/GroupsListItem/GroupsListItem.vue"
export default component.exports